import { MessageBox } from "element-ui";
import router from "@/router";
import store from "@/store";

// 检查店铺是否过期
let comboExpiredTimer = null;
export function checkExpiredPlan() {
  // 先清除旧的定时器
  if (comboExpiredTimer) {
    clearTimeout(comboExpiredTimer);
  }
  comboExpiredTimer = null;
  comboExpiredTimer = setTimeout(() => {
    const tenantInfo = store.state.tenant.tenantInfo;
    if (tenantInfo && tenantInfo.vendor == 2) {
      // 工商局租户
      const expireAt = Number(tenantInfo.expireAt);
      if (expireAt != -1) {
        // 判断店铺到期时间和当前时间
        const nowTime = Math.round(new Date().getTime() / 1000);
        if (nowTime >= expireAt) {
          MessageBox.alert(
            "您的店铺已到期，请及时联系您的上级管理员续期!",
            "店铺到期",
            {
              customClass: "noButtonMessageBox",
              closeOnClickModal: false,
              center: true,
              showCancelButton: false,
              showConfirmButton: false,
              showClose: false,
              closeOnPressEscape: false,
              type: "warning"
            }
          );
        }
      }
    }
  }, 1500);
}

// 流量、存储空间用完(购买)提示, 或套餐(升级)提示
// commerceTipe 工商局租户操作提示
// normalTipe 普通租户操作提示
export function finishMessageBox(
  title,
  content,
  commerceTipe,
  normalTipe,
  path
) {
  const tenantInfo = store.state.tenant.tenantInfo;
  if (tenantInfo && tenantInfo.vendor == 2) {
    // 工商局租户
    MessageBox.alert(
      `${content}请联系您的上级管理员及时${commerceTipe}。`,
      title,
      {
        customClass: "noButtonMessageBox",
        closeOnClickModal: false,
        center: true,
        showCancelButton: false,
        showConfirmButton: false,
        type: "warning"
      }
    );
  } else {
    // 普通租户
    MessageBox.alert(`${content}赶紧去${normalTipe}吧。`, title, {
      closeOnClickModal: false,
      center: true,
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "取消",
      confirmButtonText: `去${normalTipe}`
    })
      .then(() => {
        router.push({
          path
        });
      })
      .catch(() => {});
  }
}



// WEBPACK FOOTER //
// ./src/lib/element/messageBox.js